export type SortDirection = 'asc' | 'desc' | null;

export interface SortState<T = string> {
  column: T | null;
  direction: SortDirection;
}

export const getUpdatedSortState = <T = string>(
  currentState: SortState<T>,
  column: T
): SortState<T> => {
  let direction: SortDirection = 'asc';

  if (currentState?.column === column && currentState.direction === 'asc') {
    direction = 'desc';
  }

  return {
    column,
    direction,
  };
};

const DATE_COLUMNS = new Set(['datecreated', 'lastupdate', 'uploaddate', 'downloadDate']);

export function sortData<T>(
  data: T[],
  sortState: SortState<keyof T>
): T[] {
  const { column, direction } = sortState;
  if (!column || !direction) return data;

  return [...data].sort((a, b) => {
    const valA = a[column];
    const valB = b[column];

    if (typeof valA === 'number' && typeof valB === 'number') {
      return direction === 'asc' ? valA - valB : valB - valA;
    }

     if (DATE_COLUMNS.has(String(column))) {
      const dateA = new Date(valA as any).getTime();
      const dateB = new Date(valB as any).getTime();
      return direction === 'asc' ? dateA - dateB : dateB - dateA;
    }
 
    const strA = (valA ?? '').toString().toLowerCase();
    const strB = (valB ?? '').toString().toLowerCase();

    return direction === 'asc'
      ? strA.localeCompare(strB, undefined, { numeric: true })
      : strB.localeCompare(strA, undefined, { numeric: true });
  });
}

export const sessionCheck = (): boolean => {
  const storedData = localStorage.getItem("kfone-store");
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      const isSessionTimedOut = parsedData?.state?.isSessionTimedOut;
      return isSessionTimedOut;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
};